const SvgCpu = (props) => (
  <svg height="1em" viewBox="0 0 24 24" width="1em" {...props}>
    <path
      d="M18.667 18.667H5.333V5.333h13.334v13.334zm5.333-8V8h-2.667V5.333c0-1.48-1.2-2.666-2.666-2.666H16V0h-2.667v2.667h-2.666V0H8v2.667H5.333a2.657 2.657 0 0 0-2.666 2.666V8H0v2.667h2.667v2.666H0V16h2.667v2.667a2.667 2.667 0 0 0 2.666 2.666H8V24h2.667v-2.667h2.666V24H16v-2.667h2.667a2.667 2.667 0 0 0 2.666-2.666V16H24v-2.667h-2.667v-2.666H24zm-10.667 2.666h-2.666v-2.666h2.666v2.666zM16 8H8v8h8V8z"
      fill="currentColor"
      fillRule="nonzero"
    />
  </svg>
)

export default SvgCpu
